import React from "react";
import PageTitle from "../components/PageTitle";
import ScheduleSection from "../Schedule";
import PageCarousel from "./PageCarousels";

const WeSellPage = () => {
  PageTitle(
    "We Sell - Right Cash - We Buy, We Sell, Buybacks, Pawnbrokers. Get Cash Fast - Chatham, Kent - Pawn Shop"
  );
  return (
    <div>
      <div class="page-header">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h2>WE SELL</h2>
            </div>
            <div class="col-12">
              <a href="">Home</a>
              <a href="">We sell</a>
            </div>
          </div>
        </div>
      </div>
      <PageCarousel collectionName="wesell_banner" />
      <div class="about wow fadeInUp" data-wow-delay="0.1s">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-5 col-md-6">
              <div class="about-img">
                <img src="img/wesell1.png" alt="Image" />
              </div>
            </div>
            <div class="col-lg-7 col-md-6">
              <div class="section-header text-left">
                {/* <p>Welcome to RightCash</p> */}
                <h2>We Sell</h2>
              </div>
              <div class="about-text">
                <p>
                  Dreaming of a stunning bracelet for her? Or maybe a sleek new
                  phone for your daughter? At Right Cash, it’s all within reach!
                  We deal in a whole variety of items—think gaming consoles,
                  mobile phones, watches—plus a selection of gold and silver
                  pieces. Our large range of items come at fantastic prices
                  you’ll love!
                </p>

                <p>
                  See something you adore but short on cash? No problem—we’ll
                  reserve it for you with our deposit scheme, and you can pay in
                  easy instalments.{" "}
                </p>
                {/* <p>
                  We sell all manner of items at excellent prices in-store. Why
                  not pop in and see what we have?
                </p>
                <ul>
                  <li>Jewellery</li>
                  <li>Laptops</li>
                  <li>Mobile Phones</li>
                  <li>Flat Screen TV’s</li>
                  <li>HiFi & Audio Equipment</li>
                  <li>Cameras & Photography Equipment</li>
                  <li>And much much more</li>
                </ul> */}

                <a
                  class="btn"
                  href="https://api.whatsapp.com/send?phone=447871092759"
                >
                  Contact our team to find out more!{" "}
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 mymargins">
            <div class="about-img">
              <img src="img/wesell_products.png" alt="Image" />
            </div>
          </div>
        </div>
      </div>
      <style>{`
      .mymargins{
        margin-top:40px;
      }
      `}</style>
      <ScheduleSection />
    </div>
  );
};

export default WeSellPage;
